sc-price-choices {
  display: block;
  position: relative;
}

sc-block-ui {
  z-index: 9;
}
